var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("Redirecionadores: ")]),_c('Tree',{attrs:{"nodes":_vm.tree,"root":true}}),_c('div',{staticClass:"btn-ok",on:{"click":_vm.close}},[_vm._v("Ok")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }